import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI)

import UpdateDetector from "@/utils/UpdateDetector.js";  // 根据实际路径调整
Vue.use(UpdateDetector);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
